export default [
    {
        path: '/admin/hr/status-reasons',
        name: 'status-reason',
        meta: { requiresAuth: true },
        component: () => import('@/pages/human-resource/employee-status-reason/index.vue')
    }
]
